<template>
  <div>
    <div class="text-center mb-4 text-base-90">
      <h3 class="text-2xl">
        {{ $i18nPresenter.t('Compare Plans') }}
      </h3>
    </div>
    <div class="sticky-wrapper " :class="billingCycle" id="sticky-wrapper">
      <div
        class="sticky-plan-bar"
        :class="{
          [billingCycle]: true,
          'is-sticky': isHeaderSticky
        }"
      >
        <div class="container sticky-bar-container">
          <div class="plans-row">
            <div
              class="plans-row__picker"
              :class="{
                [billingCycle]: true,
                'is-visible': isHeaderSticky,
              }"
              id="plans-row-picker"
            >
              <aha-select
                v-if="billingCycle !== 'educational'"
                class="py-3 w-36"
                :value="billingCycle"
                @change="(e) => changePlan(e)"
              >
                <aha-select-option value="annual">
                  {{ $i18nPresenter.t('Yearly plans') }}
                </aha-select-option>
                <aha-select-option value="monthly">
                  {{ $i18nPresenter.t('Monthly plans') }}
                </aha-select-option>
              </aha-select>
            </div>
            <div class="plans-row__items mb-3 text-base-90">
              <div
                v-for="(item, index) in getPricings"
                :key="'pricing-' + index"
                class="text-center flex-grow pt-1.25 pb-1.25 flex-basis-0"
              >
                <h4 class="font-bold text-lg mb-2">
                  {{ item['label'] }}
                  <img :src="require('@/assets/images/pricing/'+ (index+1)+'.svg' )" class="inline -mt-3">
                </h4>

                <span class="mb-2 flex flex-col">
                  <span class="font-bold text-xl mr-0.5">
                    <span class="font-bold text-xl">{{ symbolCurrency }}</span>{{ item['price'] }}<span class="text-base-70 font-normal text-sm ">{{ (item['price'] == 0 || typeof item['price'] === 'string')? '' : `.${item['smaller-price']}` }}</span>
                  </span>
                  <span
                    class="text-base-70 text-sm "
                    v-if="item['price'] > 0 || item['price'].length> 0 "
                  >  {{ $i18nPresenter.t('per month') }}
                  </span>
                </span>

                <div
                  class="upgrade-buttons"
                  :class="{
                    'visible': isHeaderSticky
                  }"
                >
                  <aha-button
                    v-if="item['label'] !== 'Free'"
                    :disabled="permission[item.permissionKey] || isCreatingCustomerPortal"
                    class="min-w-32"
                    @click="goToUpgradePage(item)"
                  >
                    {{ $i18nPresenter.t('Upgrade') }}
                  </aha-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div
          v-for="(featuresInSection, featureSectionName) in features"
          :key="featureSectionName"
        >
          <div v-if="!byPassSection.includes(featureSectionName)" class="mb-5">
            <div class="section-name">
              <div class="tc__header-title">
                {{ $i18nPresenter.t(uppercaseSectionName(featureSectionName)) }}
              </div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
              <div class="flex-grow flex-basis-0"></div>
            </div>
            <div
              v-for="(feature, key, fIndex) in featuresInSection"
              :key="key + '-' + fIndex"
              class="flex items-stretch max-h-12 min-h-8 px-0"
            >
              <div class="flex-grow text-base text-left flex-basis-0 tc__cell--feature-name py-4">
                <span>
                  <span>{{ $i18nPresenter.t(feature.title) }}</span>
                  <span class="items-center tooltip" v-tooltip="$i18nPresenter.t(feature.tooltipVal)">
                    <i class="fa fa-question-circle" aria-hidden="true"></i>
                  </span>
                </span>
              </div>
              <div
                v-for="(item, kIndex) in feature.planVal"
                :key="key + '-' + item + '-' + kIndex"
                class="flex-grow text-center text-section-title flex-basis-0 tc__cell--feature-value py-4"
              >
                <span v-if="typeof(item) === 'boolean' && item" class="font-bold text-primary-90 text-xl">✓</span>
                <span
                  v-else-if="typeof(item) === 'boolean' && !item"
                  class="text-base-50 text-xl"
                >✗</span>

                <span
                  v-else-if="key === 'max-participants'"
                  class="font-bold"
                >
                  <aha-icon
                    name="user-solid"
                    width="12"
                    height="12"
                    viewBox="0 0 16 17"
                    class="-mt-0.5"
                  />
                  {{ item }}
                </span>
                <span
                  v-else
                >
                  {{ item }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/util'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'

export default {
  mixins: [PaymentLocalizationMixin],
  props: {
    scrollToPricing: {
      type: Function,
      default: () => {},
    },
    tooglePlanDropdown: {
      type: Function,
      default: () => {},
    },
    togglePlan: {
      type: Function,
      default: () => {},
    },
    features: {
      type: Object,
      default: () => {},
    },
    billingCycle: {
      type: String,
      default: 'annual',
    },
    permission: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      byPassSection: ['planPrices', 'plansDropdown'],
      dataPlansDropdown: [],
      isHeaderSticky: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      isCreatingCustomerPortal: (state) => state.isCreatingCustomerPortal,
    }),

    getPlansDropdown() {
      let plans = this.features.plansDropdown
      if (plans) {
        plans = plans.filter((item) => {
          return item.plan !== 'educational'
        })
      }
      return plans
    },
    getPricings() {
      return this.features.planPrices
    },
    getFeaturePlans() {
      return this.features
    },
  },

  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted() {
    this.dataPlansDropdown = this.getPlansDropdown
  },
  methods: {
    ...mapActions(['createCheckoutSessionForPersonPlan', 'createCustomerPortalUpgradeFlowAction']),
    goToUpgradePage(price) {
      const { upgradeLink: url } = price
      const plan = /content=([^&]+)/.exec(url)[1] || ''
      const planType = `${plan}`
      Utils.mixpanelTracking('My plan > Upgrade > Bottom', 'Upgrade', planType)
      const payload = {
        plan: price.planKey,
      }
      if (this.currentUser.plan !== 'free') {
        this.createCustomerPortalUpgradeFlowAction(payload)
      } else {
        this.createCheckoutSessionForPersonPlan(payload)
      }
    },
    getPlansTitle(billingCycle) {
      if (billingCycle === 'annual') {
        return this.$i18nPresenter.t('Yearly plans')
      }
      if (billingCycle === 'monthly') {
        return this.$i18nPresenter.t('Monthly plans')
      }
      if (billingCycle === 'educational') {
        return this.$i18nPresenter.t('Educational plans')
      }
      return null
    },
    uppercaseSectionName(name) {
      return `${name[0].toUpperCase()}${name.slice(1)}`
    },
    changePlan(plan) {
      this.togglePlan(plan)
    },

    handleScroll() {
      const stickyBar = document.getElementsByClassName('sticky-plan-bar')[0]
      const stop = stickyBar.getBoundingClientRect().top + window.scrollY - 120
      const docBody = document.documentElement || document.body.parentNode || document.body
      const hasOffset = window.pageYOffset !== undefined
      let scrollTop
      // eslint-disable-next-line prefer-const
      scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop

      if (scrollTop >= stop) {
        this.isHeaderSticky = true
      } else if (scrollTop <= stop - 50) {
        this.isHeaderSticky = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .text-section-title {
    font-size: 14px;
  }

  .compare-button {
    background-color: #fff;
    color: rgba(0, 0, 0, 0.75);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    font-size: 16px;
    padding: 8px 0;
    width: auto;
    padding: 10px 24px 10px 12px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    & .dropdown-icon {
      position: absolute;
      top: 12px;
      right: 10px;
    }
  }

  .compare-button .fa {
    font-size: 16px !important;
  }
  .tooltip {
    position: relative;
  }
  .tooltip.items-center {
    z-index: unset;

    cursor: pointer;
    padding-left: 5px;
    display: unset !important;
  }

  .tooltip.items-center .fa-question-circle {
    font-size: 13px;
    color: #AFAFAF;
  }

  .section-name {
    background: #ddecff;
  }

  .tc__header-title {
    flex-basis: 270px;
    flex-grow: 0;
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
  }

  .tc__row--gray {
    background-color: rgba(0, 0, 0, 0.02);
    border-radius: 100px;
  }
  .flex-basis-0 {
    flex-basis: 0;
  }

  .tc__cell--feature-name {
    max-width: 270px;
    flex-basis: 270px;
    padding: 5px 0 5px 16px;
    color: #313131;
    text-align: left;
    white-space: pre-line;
    display: flex;
    align-items: center;
    line-height: 18px;
  }
  .tc__cell--feature-value {
    color: #313131;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:not(:last-of-type) {
      border-right: 1px solid #ddd;
    }
  }

  .plans-row {
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;
    align-items: center;
    margin: 0 auto;
  }
  .flex-grow-0 {
    flex-grow: 0;
  }
  .buttons-row__item--green {
    background-color: rgba(112, 190, 78, 0.04);
    border-left: 2px solid rgba(112, 190, 78, 0.2);
    border-right: 2px solid rgba(112, 190, 78, 0.2);
    border-bottom: 2px solid rgba(112, 190, 78, 0.2);
  }
  .plans-row__picker {
    transition: opacity .3s ease;
    opacity: 0;
    visibility: hidden;
    flex-basis: 270px;
    flex-grow: 0;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 16px;
  }
  .plans-row__picker.is-visible {
    opacity: 1;
    visibility: visible;
  }
  .plans-row__dropdown.is-visible {
    display: block;
  }
  .plans-row__dropdown a {
    color: inherit;
  }
  .plans-row__dropdown {
    position: absolute;
    z-index: 2;
    width: 155px;
    top: 100%;
    left: 20px;
    display: none;
    transform: translateY(5px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }

  .upgrade-buttons {
    opacity: 0;
    height: 0;
    transition: all 0.3s ease;
    &.visible {
      opacity: 1;
      height: 40px;
    }

  }
  .plans-row__dropdown-triangle {
    width: 14px;
    height: 14px;
    position: absolute;
    transform: rotate(45deg) translateX(-50%);
    top: -2px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    z-index: 0;
    left: 50%;
  }
  .plans-row__dropdown-content {
    background-color: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    position: relative;
    z-index: 1;
    padding-left: 20px;
  }
  .plans-row__items {
    display: flex;
    align-items: center;
    flex-basis: 0;
    flex-grow: 1;
    color: #313131;
  }
  .sticky-plan-bar {
    position: static;
    width: auto;
    box-shadow: none;
    background-color: #fff;
    z-index: 3;
    padding-top: 10px;
    transition: top .3s ease;
    transform-style: preserve-3d;
    backface-visibility: hidden;
  }
  .sticky-plan-bar.is-sticky {
    position: sticky;
    width: 100%;
    box-shadow: 0 15px 5px -15px rgba(0, 0, 0, 0.1);
    top: 3.7rem;
    padding-top: 5px;
    left: 0;
  }
  .items-stretch:not(:last-of-type) {
    border-bottom: 1px solid #eee;
  }

  .items-stretch {
    .tooltip {
      transition: opacity 0.2s ease;
      opacity: 0;
    }
    &:hover .tooltip {
      opacity: 1;
    }
  }

  #sticky-wrapper {
    position: relative;
  }
</style>
